import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Button } from 'primereact/button';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { USER_TYPES } from '../../constants';

export const useModuleOptions = (catalog) => {
    const { th } = useLanguage();
    return [{ value: null, label: th('authorizationV2.role.noModule') }, ...catalog.map((m) => ({ value: m.code, label: th(`authorizationV2.modules.${m.code}`, { fallback: m.name }) }))];
};

export const useUserTypeOptions = () => {
    const { th } = useLanguage();
    return [
        { value: null, label: th('authorizationV2.userTypes.both') },
        { value: USER_TYPES.KARSAN, label: th('authorizationV2.userTypes.karsan') },
        { value: USER_TYPES.DEALER, label: th('authorizationV2.userTypes.dealer') }
    ];
};

const toFormValues = (settings) => ({
    description: settings?.description || '',
    moduleCode: settings?.moduleCode || null,
    priority: settings?.priority ?? 0,
    assignableUserType: settings?.assignableUserType ?? null,
    isActive: settings?.isActive ?? true
});

const RoleSettingsForm = ({ settings, catalog, readOnly, saving, onSave }) => {
    const { th } = useLanguage();
    const [values, setValues] = useState(toFormValues(settings));
    const moduleOptions = useModuleOptions(catalog);
    const userTypeOptions = useUserTypeOptions();

    useEffect(() => setValues(toFormValues(settings)), [settings]);

    const change = (field, value) => setValues((prev) => ({ ...prev, [field]: value }));

    return (
        <div className="grid formgrid p-fluid">
            <div className="field col-12">
                <label htmlFor="roleDescription" className="font-bold">
                    {th('authorizationV2.role.description')}
                </label>
                <InputText id="roleDescription" value={values.description} onChange={(e) => change('description', e.target.value)} disabled={readOnly} maxLength={256} />
            </div>
            <div className="field col-12 md:col-6">
                <label htmlFor="roleModule" className="font-bold">
                    {th('authorizationV2.role.module')}
                </label>
                <Dropdown inputId="roleModule" value={values.moduleCode} options={moduleOptions} onChange={(e) => change('moduleCode', e.value)} disabled={readOnly} />
                <small className="text-color-secondary">{th('authorizationV2.role.moduleHint')}</small>
            </div>
            <div className="field col-12 md:col-6">
                <label htmlFor="rolePriority" className="font-bold">
                    {th('authorizationV2.role.priority')}
                </label>
                <InputNumber inputId="rolePriority" value={values.priority} onValueChange={(e) => change('priority', e.value ?? 0)} min={0} max={1000} showButtons disabled={readOnly || !values.moduleCode} />
                <small className="text-color-secondary">{th('authorizationV2.role.priorityHint')}</small>
            </div>
            <div className="field col-12 md:col-6">
                <label htmlFor="roleUserType" className="font-bold">
                    {th('authorizationV2.role.assignableUserType')}
                </label>
                <Dropdown inputId="roleUserType" value={values.assignableUserType} options={userTypeOptions} onChange={(e) => change('assignableUserType', e.value)} disabled={readOnly} />
            </div>
            <div className="field col-12 md:col-6">
                <label htmlFor="roleActive" className="font-bold block">
                    {th('authorizationV2.role.isActive')}
                </label>
                <InputSwitch inputId="roleActive" checked={values.isActive} onChange={(e) => change('isActive', e.value)} disabled={readOnly} />
            </div>
            {!readOnly && (
                <div className="col-12 flex justify-content-end">
                    <Button type="button" icon="pi pi-save" label={th('common.save')} loading={saving} onClick={() => onSave(values)} className="w-auto" />
                </div>
            )}
        </div>
    );
};

export default RoleSettingsForm;
